import React from "react";
import { Switch } from "@merge-api/merge-javascript-shared";
import { Sparkles } from "lucide-react";

interface FieldMappingModalSwitchProps {
  switchValue: string;
  setSwitchValue: (value: string) => void;
}

export enum FieldMappingSwitchValue {
  Generated = "Generated",
  Manual = "Manual",
}

const FieldMappingModalSwitch = ({ switchValue, setSwitchValue }: FieldMappingModalSwitchProps) => {
  return (
    <Switch
      options={[
        { label: "Generated", value: "Generated", icon: <Sparkles size={16} /> },
        { label: "Manual", value: "Manual" },
      ]}
      value={switchValue}
      onChange={setSwitchValue}
    />
  );
};

export default FieldMappingModalSwitch;
